<template>
    <div>
        <!-- !is24Hours &&   -->
        <!-- <div class="page" v-if="formlist.merchantState!=-1 && formlist.contractState>=1 && formlist.contractState<=3 && ((button.includes('btn_milifeadd') && (sid=='' || sid==-1)) || (button.includes('btn_milifeedit') && sid!='' && sid!=-1))">
            <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit" v-if="sid=='' || sid==-1">
                <van-field label="门店名称" v-model="form.shopName" name="shopName" placeholder="请填写门店名称" readonly/>
                <van-field label="合同号" v-model="form.contractNo" name="contractNo" placeholder="请填写合同号" readonly />
                <van-field label="合同唯一号" v-model="form.contractOnlyId" name="contractOnlyId" placeholder="请填写门店名称" readonly/>
                <van-field label="品牌名称" v-model="form.brandName" name="brandName" placeholder="请填写品牌名称" readonly />
                <van-field label="业态分类" v-model="form.businessFormatName" name="businessFormat" placeholder="请选择业态分类" readonly />
                <van-field label="计租面积" v-model="form.businessArea" name="businessArea" placeholder="请填写计租面积" :readonly="is24Hours || form.contractState==-1 || form.contractState>3" />
                <van-field label="招采对接人" required v-model="form.recruitmentLiaison" name="recruitmentLiaison" placeholder="请填写招采对接人" :rules="[{ required: true, message: '请填写招采对接人' }]" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-field label="品牌对接人" required v-model="form.brandLiaison" name="brandLiaison" placeholder="请填写品牌对接人" :rules="[{ required: true, message: '请填写品牌对接人' }]" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-field name="advertisingSpaceFlag" label="是否有广告位1" required :rules="[{ required: true, message: '请选择是否有广告位' }]">
                    <template #input>
                        <van-radio-group v-model="form.advertisingSpaceFlag" direction="horizontal" :readonly="is24Hours || form.contractState==-1 || form.contractState>3">
                        <van-radio name="0">否</van-radio>
                        <van-radio name="1">是</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field label="广告位置及说明" v-model="form.advertisingSpaceExplain" rows="2" autosize type="textarea" placeholder="请填写广告位置及说明" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-field label="电费标准(元/度)" label-width="7em" required v-model="form.electricityTariffStandard" name="electricityTariffStandard" placeholder="请填写电费标准" :rules="[{ required: true, message: '请填写电费标准' }]" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-field label="水费标准(元/吨)" label-width="7em" required v-model="form.waterFeeStandard" name="waterFeeStandard" placeholder="请填写水费标准" :rules="[{ required: true, message: '请填写水费标准' }]" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>

                <van-field label="合同签署情况" v-model="form.contractStateName" name="contractState" placeholder="请填写合同签署情况" readonly/>
                <van-field label="供应商名称" v-model="form.supplyName" name="waterFeeStandard" placeholder="请填写供应商名称" readonly/>
                <van-field label="经营类型" required v-model="form.businessTypeName" name="businessType" placeholder="请填写经营类型" readonly :rules="[{ required: true, message: '请填写经营类型' }]"/>
                <van-field label="楼层位置" required v-model="form.floorLocation" name="floorLocation" placeholder="请填写楼层位置" :rules="[{ required: true, message: '请填写楼层位置' }]" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-field label="原铺品牌" v-model="form.originalStoreBrand" name="originalStoreBrand" placeholder="请填写原铺品牌" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-field label="品牌联系方式" required v-model="form.brandContactInformation" name="brandContactInformation" placeholder="请填写品牌联系方式" :rules="[{ required: true, message: '请填写品牌联系方式' },{validator: (value) => /^(0\d{2,3}-\d{7,8}|1[3-9]\d{9})$/.test(value),message: '请输入正确的手机号或电话号码'}]" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-field label="计租时间" required v-model="form.billingDate" is-link readonly name="billingDate" placeholder="请选择计租时间" @click="gettype('billingDate',item)"/>
                <van-field label="装修免租期" required v-model="form.rentFreePeriod" name="rentFreePeriod" placeholder="请填写装修免租期" :rules="[{ required: true, message: '请填写装修免租期' }]" :readonly="is24Hours || form.contractState==-1 || form.contractState>3">
                    <template #button>天</template>
                </van-field>
                <van-field label="交房时间" required v-model="form.deliveryTime" is-link readonly name="deliveryTime" placeholder="请选择交房时间" @click="gettype('deliveryTime',item)" :rules="[{ required: true, message: '请选择交房时间' }]"/>
                <van-field label="交房特殊约定" v-model="form.deliveryAgreement" rows="2" autosize  type="textarea" placeholder="请填写交房特殊约定" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-field label="商户计划进场时间" label-width="8em" required v-model="form.entryTime" is-link readonly name="entryTime" placeholder="请选择商户计划进场时间" @click="gettype('entryTime',item)" :rules="[{ required: true, message: '请选择商户计划进场时间' }]"/>
                <van-field label="进场特殊约定" v-model="form.entryAgreement" rows="2" autosize type="textarea" placeholder="请填写进场特殊约定" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-field label="其他特殊说明" v-model="form.supplementaryInformation" rows="2" autosize type="textarea" placeholder="请填写其他特殊说明" :readonly="is24Hours || form.contractState==-1 || form.contractState>3"/>
                <van-calendar title="选择日期" color="#3332B5" v-model="show" @confirm="onConfirmtwo" />
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit" :loading="btnloading">保存</van-button>
                </div>
            </van-form>
            <div v-else>
                <van-collapse v-model="oneactive">
                    <van-collapse-item title="基础信息" v-for="(item,index) in form.lifecycleInfoList" :key="index" :name="index+1" >
                        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit">
                            <van-field label="门店名称" v-model="item.shopName" name="shopName" placeholder="请填写门店名称" readonly/>
                            <van-field label="合同号" v-model="item.contractNo" name="contractNo" placeholder="请填写合同号" readonly />
                            <van-field label="合同唯一号" v-model="item.contractOnlyId" name="contractOnlyId" placeholder="请填写门店名称" readonly/>
                            <van-field label="品牌名称" v-model="item.brandName" name="brandName" placeholder="请填写品牌名称" readonly />
                            <van-field label="业态分类" v-model="item.businessFormatName" name="businessFormat" placeholder="请选择业态分类" readonly />
                            <van-field label="计租面积" v-model="item.businessArea" name="businessArea" placeholder="请填写计租面积" :readonly="is24Hours || item.contractState==-1 || item.contractState>3" />
                            <van-field label="招采对接人" required v-model="item.recruitmentLiaison" name="recruitmentLiaison" placeholder="请填写招采对接人" :rules="[{ required: true, message: '请填写招采对接人' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-field label="品牌对接人" required v-model="item.brandLiaison" name="brandLiaison" placeholder="请填写品牌对接人" :rules="[{ required: true, message: '请填写品牌对接人' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-field name="advertisingSpaceFlag" label="是否有广告位" required :rules="[{ required: true, message: '请选择是否有广告位' }]">
                                <template #input>
                                    <van-radio-group v-model="item.advertisingSpaceFlag" direction="horizontal" :disabled="item.contractState>=1 && item.contractState<=3?false:true">
                                    <van-radio name="0">否</van-radio>
                                    <van-radio name="1">是</van-radio>
                                    </van-radio-group>
                                </template>
                            </van-field>
                            <van-field label="广告位置及说明" v-model="item.advertisingSpaceExplain" rows="2" autosize type="textarea" placeholder="请填写广告位置及说明" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-field label="电费标准(元/度)" label-width="7em" required v-model="item.electricityTariffStandard" name="electricityTariffStandard" placeholder="请填写电费标准" :rules="[{ required: true, message: '请填写电费标准' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-field label="水费标准(元/吨)" label-width="7em" required v-model="item.waterFeeStandard" name="waterFeeStandard" placeholder="请填写水费标准" :rules="[{ required: true, message: '请填写水费标准' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>

                            <van-field label="合同签署情况" v-model="item.contractStateName" name="contractState" placeholder="请填写合同签署情况" readonly/>
                            <van-field label="供应商名称" v-model="item.supplyName" name="waterFeeStandard" placeholder="请填写供应商名称" readonly/>
                            <van-field label="经营类型" required v-model="item.businessTypeName" name="businessType" placeholder="请填写经营类型" readonly :rules="[{ required: true, message: '请填写经营类型' }]"/>
                            <van-field label="楼层位置" required v-model="item.floorLocation" name="floorLocation" placeholder="请填写楼层位置" :rules="[{ required: true, message: '请填写楼层位置' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-field label="原铺品牌" v-model="item.originalStoreBrand" name="originalStoreBrand" placeholder="请填写原铺品牌" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-field label="品牌联系方式" required v-model="item.brandContactInformation" name="brandContactInformation" placeholder="请填写品牌联系方式" :rules="[{ required: true, message: '请填写品牌联系方式' },{validator: (value) => /^(0\d{2,3}-\d{7,8}|1[3-9]\d{9})$/.test(value),message: '请输入正确的手机号或电话号码'}]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-field label="计租时间" required v-model="item.billingDate" is-link readonly name="billingDate" placeholder="请选择计租时间" @click="gettype('billingDate',item)"/>
                            <van-field label="装修免租期" required v-model="item.rentFreePeriod" name="rentFreePeriod" placeholder="请填写装修免租期" :rules="[{ required: true, message: '请填写装修免租期' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3">
                                <template #button>天</template>
                            </van-field>
                            <van-field label="交房时间" required v-model="item.deliveryTime" is-link readonly name="deliveryTime" placeholder="请选择交房时间" @click="gettype('deliveryTime',item)" :rules="[{ required: true, message: '请选择交房时间' }]"/>
                            <van-field label="交房特殊约定" v-model="item.deliveryAgreement" rows="2" autosize  type="textarea" placeholder="请填写交房特殊约定" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-field label="商户计划进场时间" label-width="8em" required v-model="item.entryTime" is-link readonly name="entryTime" placeholder="请选择商户计划进场时间" @click="gettype('entryTime',item)" :rules="[{ required: true, message: '请选择商户计划进场时间' }]"/>
                            <van-field label="进场特殊约定" v-model="item.entryAgreement" rows="2" autosize type="textarea" placeholder="请填写进场特殊约定" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-field label="其他特殊说明" v-model="item.supplementaryInformation" rows="2" autosize type="textarea" placeholder="请填写其他特殊说明" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                            <van-calendar title="选择日期" color="#3332B5" :min-date="minDate" v-model="show" @confirm="onConfirmtwo" />
                            <div style="margin: 16px;" v-if="((button.includes('btn_milifeadd') && (sid=='' || sid==-1)) || (button.includes('btn_milifeedit') && sid!='' && sid!=-1)) && item.contractState>=1 && item.contractState<=3">
                                <van-button round block type="info" native-type="submit" :loading="btnloading">保存</van-button>
                            </div>
                        </van-form>
                    </van-collapse-item>
                </van-collapse>
                <van-collapse v-model="activeNames">
                    <van-collapse-item title="生命周期进度" name="1" v-if="button.includes('btn_milifeviewdetail')">
                        <van-cell-group class="noline rebox bhbj">
                            <van-cell :class="item.confirmFlag==1?'lv':'jg'" :title="getprosub(item.lifecycleProgressSub)" :value="item.confirmFlag==1?'已完成':'待完成'"  v-for="(item,index) in formlist.progressList" :key="index"/>
                        </van-cell-group>
                    </van-collapse-item>
                    <div v-for="(item,index) in formlist.progressList" :key="index">
                        <van-collapse-item title="首期费用收缴" :name="(Number(index)+2)" v-if="item.lifecycleProgressSub==21 && button.includes('btn_milifeviewdetail')">
                            <div class="row-flex" slot="title">
                            首期费用收缴
                            <span v-if="(item.confirmTime!='' && item.confirmTime!=null)" class="lan">{{gettime(item.confirmTime)}}</span>
                        </div>
                            <van-grid border :row-num="8/4">
                                <van-grid-item text="" />
                                <van-grid-item text="收付款单号" />
                                <van-grid-item text="应付金额(元)" />
                                <van-grid-item text="已付金额(元)" />
                            </van-grid>
                            <van-grid border :row-num="8/4" v-for="(otem,nindex) in formlist.paymentItemList" :key="nindex">
                                <van-grid-item :text="otem.costName" />
                                <van-grid-item :text="otem.paymentReceiptNo" />
                                <van-grid-item :text="otem.payableAmount" />
                                <van-grid-item :text="otem.amountPaid" />
                            </van-grid>
                            <van-cell-group class="noline rebox m-t-15">
                                <van-cell title="应收总金额（元）" :value="yamount+'元'" />
                                <van-cell title="实收总金额（元）" :value="samount+'元'" />
                                <van-cell title="未收总金额（元）" :value="wamount+'元'" />
                            </van-cell-group>
                            <van-divider :margin="12" />
                            <div class="dlist">
                                <div class="m-b-15">
                                    <van-cell-group class="noline rebox" v-for="(otem,nindex) in item.approvalProcessList" :key="nindex">
                                        <van-cell class="tit" title="钉钉审批号" :value="otem.businessId" />
                                        <van-cell title="备注" :value="otem.memo" />
                                        <van-cell title="操作人" :value="otem.operatorName" />
                                        <van-cell title="操作时间" :value="otem.operationTime" />
                                    </van-cell-group>
                                </div>
                                <van-divider :margin="12" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3"/>
                                <div class="mauto" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3">
                                    <van-button type="info" size="small" color="#3332B5" @click="getding(item.lifecycleProgressSub)">特批通过</van-button>
                                </div>
                            </div>
                        </van-collapse-item>
                    
                        <van-collapse-item title="当前工程作业" :name="(Number(index)+2)" v-if="item.lifecycleProgressSub==31">
                            <div class="row-flex" slot="title">
                            当前工程作业
                            <span v-if="(item.operationTime!='' && item.operationTime!=null)" class="lan">{{gettime(item.operationTime)}}</span>
                        </div>
                            <van-cell-group class="shadow" v-for="(otem,nindex) in formlist.engineeringList" :key="nindex">
                                <van-cell title="工程要求" :value="otem.merchantRequirements" />
                                <van-cell title="招商操作人" :value="otem.investmentOperatorName" />
                                <van-cell title="招商操作时间" :value="otem.investmentOperationTime" />
                                <van-cell title="工程反馈" :value="otem.engineeringFeedback" />
                                <van-cell title="工程操作人" :value="otem.engineeringOperatorName" />
                                <van-cell title="工程操作时间" :value="otem.engineeringOperationTime" />
                                <div class="mt20 mb20" v-if="(otem.engineeringOperationTime=='' || otem.engineeringOperationTime==null) && formlist.contractState>=1 && formlist.contractState<=3">
                                    <van-button type="info" size="small" color="#3332B5" @click="addFeedback(otem)">确认完成</van-button>
                                </div>
                            </van-cell-group>
                            <van-empty
                            v-if="formlist.engineeringList.length==0"
                            class="custom-image"
                            image="https://maindata-1319309047.cos.ap-beijing.myqcloud.com/image/2025/07/30/1753843734091866.png"
                            description="暂无内容"/>
                            <div class="mt20" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3">
                                <van-button type="info" size="small" color="#3332B5" @click="addmerchant()" v-if="item.confirmFlag!=1">增加一行</van-button>
                                <van-button type="info" size="small" color="#3332B5" @click="getlife(index)" v-if="item.confirmFlag!=1">进度确认</van-button>
                            </div>
                        </van-collapse-item>
                        <van-collapse-item :title="getprosub(item.lifecycleProgressSub)+'确认'" :name="(Number(index)+2)" v-if="((item.lifecycleProgressSub>=41 && item.deliveryTime!='' && item.deliveryTime!=null) || item.lifecycleProgressSub==61 || item.lifecycleProgressSub==44) && button.includes('btn_milifeviewdetail')">
                        <div class="row-flex" slot="title">
                            {{getprosub(item.lifecycleProgressSub)}}确认完成
                            <span v-if="(item.deliveryTime!='' && item.deliveryTime!=null) || (item.confirmTime!='' && item.confirmTime!=null)" :class="compareTimes(item.confirmTime,item.deliveryTime)?'red':!compareTimes(item.confirmTime,item.deliveryTime) && (item.confirmTime=='' || item.confirmTime==null)?'':'lan'">{{gettime(item.confirmTime || item.deliveryTime)}}</span>
                        </div>
                            <van-cell-group class="cnoline" v-if="item.lifecycleProgressSub!=61">
                                <van-cell :title="'预计'+getprosubtime(item.lifecycleProgressSub)+'时间'" :value="gettime(item.deliveryTime)" />
                                <van-field class="hbj" v-model="item.deliveryMemo" readonly rows="4" autosize label="交付特殊约定" type="textarea" placeholder="交付特殊约定"/>
                                <div v-if="item.lifecycleProgressSub!=46">
                                    <van-cell required :title="getprosubsjtime(item.lifecycleProgressSub)" is-link :value="gettime(item.confirmTime)" @click="getdata(index,'confirmTime')" />
                                    <van-field class="hbj" v-model="item.delayReason" rows="4" autosize label="延后原因" type="textarea" :readonly="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && ((item.lifecycleProgressSub==41 && button.includes('btn_milifehouse')) || (item.lifecycleProgressSub==42 && button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && button.includes('btn_milifeopen')))?false:true" show-word-limit placeholder="延后原因"/>
                                    <van-field required :label="getprosubdesc(item.lifecycleProgressSub)" label-width="75px" v-if="item.lifecycleProgressSub==41 || item.lifecycleProgressSub==45 || item.lifecycleProgressSub==46">
                                        <template #input>
                                            <van-uploader v-model="item.attachmenttwo" :max-count="1" :disabled="item.confirmFlag==1 || formlist.contractState==-1 || formlist.contractState>3 || ((item.lifecycleProgressSub==42 && !button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && !button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && !button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && !button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && !button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && !button.includes('btn_milifeopen')))?true:false" :deletable="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && ((item.lifecycleProgressSub==42 && button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && button.includes('btn_milifeopen')))?true:false" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index,'attachment')" :after-read="(file, detail) => afterRead(file, detail,index,'attachment')" />
                                        </template>
                                    </van-field>
                                    <van-field label="图片" label-width="75px">
                                        <template #input>
                                            <van-uploader v-model="item.imgListtwo" :disabled="item.confirmFlag==1 || formlist.contractState==-1 || formlist.contractState>3 || ((item.lifecycleProgressSub==42 && !button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && !button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && !button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && !button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && !button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && !button.includes('btn_milifeopen')))?true:false" :deletable="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && ((item.lifecycleProgressSub==42 && button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && button.includes('btn_milifeopen')))?true:false" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index,'')" :after-read="(file, detail) => afterRead(file, detail,index,'')" />
                                        </template>
                                    </van-field>
                                    <van-field label="开业验收表" label-width="75px" v-if="item.lifecycleProgressSub==51">
                                        <template #input>
                                            <div v-if="item.attachment=='' || item.attachment==null">
                                                <van-uploader v-model="item.attachmenttwo" :max-count="1" accept="image/*,.xls,.xlsx"  :before-read="beforeRead1" @delete="(file, detail) => deleteImg(file, detail,index,'attachment')" :after-read="(file, detail) => afterRead(file, detail,index,'attachment')"> 
                                                    <van-button icon="plus" type="primary" size="small">上传文件</van-button>
                                                </van-uploader>
                                            </div>
                                            <div style="width:100%" class="row-between" v-else>
                                                <van-button type="primary" size="small" @click="downfile(item)">下载文件</van-button>
                                                <van-icon name="close" @click="godel(item)" size="2em" v-if="item.confirmFlag!=1"/>
                                            </div>
                                        </template>
                                    </van-field>
                                    <van-field label=" " label-width="75px" v-if="item.lifecycleProgressSub==51 && (item.attachment=='' || item.attachment==null)">
                                        <template #input>
                                            <div class="tips">只能上传.xls,.xlsx文件</div>
                                        </template>
                                    </van-field>
                                    
                                </div>
                                <div v-else>
                                    <van-cell required :title="getprosubsjtime(item.lifecycleProgressSub)" is-link :value="gettime(item.confirmTime)" @click="getdatathree(index,'confirmTime')" />
                                    <van-field class="hbj" v-model="item.delayReason" rows="4" autosize label="延后原因" type="textarea" :readonly="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || !button.includes('btn_milifepaper') || item.isattachment?true:false" show-word-limit placeholder="延后原因"/>
                                    <van-field required :label="getprosubdesc(item.lifecycleProgressSub)" label-width="75px" v-if="item.lifecycleProgressSub==46">
                                        <template #input>
                                            <van-uploader v-model="item.attachmenttwo" :max-count="1" :disabled="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || item.isattachment || !button.includes('btn_milifepaper')?true:false" :deletable="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || !item.isattachment || !button.includes('btn_milifepaper')?true:false" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index,'attachment')" :after-read="(file, detail) => afterRead(file, detail,index,'attachment')" />
                                        </template>
                                    </van-field>
                                    <van-field label="图片" label-width="75px">
                                        <template #input>
                                            <van-uploader v-model="item.imgListtwo" :disabled="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || item.isattachment || !button.includes('btn_milifepaper')?true:false" :deletable="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || !item.isattachment || !button.includes('btn_milifepaper')?true:false" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index,'')" :after-read="(file, detail) => afterRead(file, detail,index,'')" />
                                        </template>
                                    </van-field>
                                </div>
                                <van-cell title="操作人" :value="item.operatorName" />
                                <van-cell title="操作时间" :value="item.operationTime" />
                                <div class="mauto" v-if="item.lifecycleProgressSub!=41 && item.lifecycleProgressSub!=46 && item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && ((item.lifecycleProgressSub==42 && button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==51 && button.includes('btn_milifeopen')))">
                                    <van-button :loading="loading" type="info" size="small" color="#3332B5" @click="editlifesave(item)" v-if="item.confirmFlag!=1 && item.lifecycleProgressSub==45 && button.includes('btn_milifecomplete')">保存</van-button>
                                    <van-button :loading="loading" type="info" size="small" color="#3332B5" @click="gosubmit(index)" v-if="item.confirmFlag!=1">确认</van-button>
                                </div>
                                <div v-if="item.lifecycleProgressSub==45 && formlist.inspectionList && formlist.inspectionList!=null && formlist.inspectionList.length>0">
                                    <van-divider />
                                    <van-cell title="竣工验收记录" />
                                    <van-steps direction="vertical" :active="formlist.inspectionList.length" active-color="#3332B5">
                                        <van-step v-for="(ntem,mindex) in formlist.inspectionList" :key="mindex">
                                            <p>商户实际完工时间：{{ntem.confirmTime}}</p>
                                            <p>延后原因：{{ntem.delayReason}}</p>
                                            <p>图片：</p>
                                            <p>竣工验收表：</p>
                                            <p>操作人：{{ntem.operatorName}}</p>
                                            <p>操作时间：{{ntem.operationTime}}</p>
                                        </van-step>
                                    </van-steps>
                                </div>
                            </van-cell-group>
                            <div v-if="item.lifecycleProgressSub==41">
                                <van-divider :margin="12" />
                                <van-cell-group class="cnoline" v-for="(otem,nindex) in formlist.openingPlanTimeList" :key="nindex">
                                    <van-cell required :title="getprosubtime(otem.lifecycleProgressSub)+'时间'" is-link :value="gettime(otem.scheduledTime)" @click="getdatatwo(index,nindex,'scheduledTime')" />
                                    <van-field class="hbj" v-model="otem.memo" rows="4" autosize :label="getprosubtime(otem.lifecycleProgressSub)+'备注'" type="textarea" :readonly="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && button.includes('btn_milifehouse')?false:true" show-word-limit :placeholder="getprosubtime(otem.lifecycleProgressSub)+'备注'"/>
                                </van-cell-group>
                                <div class="mauto" v-if="formlist.contractState>=1 && formlist.contractState<=3 && item.confirmFlag!=1 && button.includes('btn_milifehouse')">
                                    <van-button type="info" size="small" color="#3332B5" @click="gosubmit(index)" v-if="item.confirmFlag!=1">确认</van-button>
                                </div>
                            </div>
                            <div v-if="item.lifecycleProgressSub==46">
                                <div class="dlist">
                                    <div class="m-b-15">
                                        <van-cell-group class="noline rebox" v-for="(otem,nindex) in item.approvalProcessList" :key="nindex">
                                            <van-cell class="tit" title="钉钉审批号" :value="otem.businessId" />
                                            <van-cell title="备注" :value="otem.memo" />
                                            <van-cell title="操作人" :value="otem.operatorName" />
                                            <van-cell title="操作时间" :value="otem.operationTime" />
                                        </van-cell-group>
                                    </div>
                                    <van-divider :margin="12" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3"/>
                                    <div class="mauto" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3">
                                        <van-button type="info" size="small" color="#3332B5" @click="getding(item.lifecycleProgressSub)">特批通过</van-button>
                                    </div>
                                </div>
                                <div class="mauto" v-if="formlist.contractState>=1 && formlist.contractState<=3 && item.confirmFlag==1 && !item.isattachment && button.includes('btn_milifepaper')">
                                    <van-button type="info" size="small" color="#3332B5" @click="gosubmit(index)">确认</van-button>
                                </div>
                            </div>
                            <van-cell-group class="cnoline" v-if="item.lifecycleProgressSub==61">
                                <van-cell required :title="getprosubtime(item.lifecycleProgressSub)+'时间'" is-link :value="gettime(item.confirmTime)" @click="getdata(index,'confirmTime')" />
                                <van-field class="hbj" v-model="item.deliveryMemo" rows="4" autosize label="备注" type="textarea" :readonly="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && button.includes('btn_milifeleave')?false:true" show-word-limit placeholder="备注"/>
                                <van-cell title="操作人" :value="item.operatorName" />
                                <van-cell title="操作时间" :value="item.operationTime" />
                                <div class="mauto" v-if="formlist.contractState>=1 && formlist.contractState<=3 && item.confirmFlag!=1 && button.includes('btn_milifeleave')">
                                    <van-button :loading="loading" type="info" size="small" color="#3332B5" @click="gosubmit(index)" v-if="item.confirmFlag!=1">确认</van-button>
                                </div>
                            </van-cell-group>
                            
                        </van-collapse-item>
                    </div>
                </van-collapse>
            </div>
        </div> -->
        <!-- is24Hours ||  -->
        <!-- v-if="formlist.merchantState<0 || formlist.merchantState>3 || (sid!='' && sid!=-1 && (!button.includes('btn_milifeadd') || !button.includes('btn_milifeedit')))" -->
        <div class="page">
            <van-collapse v-model="oneactive">
                <van-collapse-item v-for="(item,index) in form.lifecycleInfoList" :key="index" :name="index+1" >
                    <div slot="title">
                        <div class="row-between">
                            <span>{{item.contractNo}}</span> 
                            <span>{{item.contractStateName}}</span>
                        </div>
                    </div>
                    <div v-if="item.contractState<1 || item.contractState>3">
                        <div class="text">
                            <div class="t_top">
                                <div class="item w100"><span>{{item.lifecycleNo}}</span></div>
                                <div class="item"><span>{{item.shopName}}</span></div>
                                <div class="item"><span>{{item.contractNo}}</span></div>
                                <div class="item"><span>{{item.supplyName}}</span></div>
                                <div class="item"><span>{{item.brandName}}</span></div>
                            </div>
                            <div class="t_box bhbj">
                                <div class="item w100">合同唯一号：<span>{{item.contractOnlyId}}</span></div>
                                <div class="item left">合同签署情况：<span>{{item.contractStateName}}</span></div>
                                <div class="item">业态分类：<span>{{item.businessFormatName}}</span></div>
                                <div class="item left">原铺品牌：<span>{{item.originalStoreBrand}}</span></div>
                                <div class="item">经营模式：<span>{{item.businessTypeName}}</span></div>
                                <div class="item left">招采对接人：<span>{{item.recruitmentLiaison}}</span></div>
                                
                                
                                <div class="item">电费标准：<span v-if="item.electricityTariffStandard>0">{{item.electricityTariffStandard}}元/度</span><span v-else>暂无</span></div>
                                
                                <div class="item left">品牌对接人：<span>{{item.brandLiaison}}</span></div>
                                
                                <div class="item">水费标准：<span v-if="item.waterFeeStandard>0">{{item.waterFeeStandard}}元/吨</span><span v-else>暂无</span></div>
                                
                                
                                <div class="item left">品牌联系方式：<span>{{item.brandContactInformation}}</span></div>
                                <div class="item">楼层位置：<span>{{item.floorLocation}}</span></div>
                                <div class="item left">计租时间：<span>{{gettime(item.billingDate)}}</span></div>
                                <div class="item">计租面积：<span>{{item.businessArea || 0}}m²</span></div>
                                
                                <div class="item left">交房时间：<span>{{gettime(item.deliveryTime)}}</span></div>
                                <div class="item">装修免租期：<span>{{item.rentFreePeriod || 0}}天</span></div>
                                <div class="item w100">交房特殊约定：<span>{{form.deliveryAgreement}}</span></div>
                                
                                <div class="item left">商户计划进场时间：<span>{{gettime(item.entryTime)}}</span></div>
                                <div class="item w100">进场特殊约定：<span>{{item.entryAgreement}}</span></div>
                                <div class="item w100">其他特殊约定：<span>{{item.supplementaryInformation}}</span></div>
                                <div class="item left">是否有广告位：<span>{{item.advertisingSpaceFlagName}}</span></div>
                                <div class="item w100">广告位置及说明：<span>{{item.advertisingSpaceExplain}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <van-form :show-error-message="false" :scroll-to-error="true" @submit="getSubmit">
                        <van-field label="门店名称" v-model="item.shopName" name="shopName" placeholder="请填写门店名称" readonly/>
                        <van-field label="合同号" v-model="item.contractNo" name="contractNo" placeholder="请填写合同号" readonly />
                        <van-field label="合同唯一号" v-model="item.contractOnlyId" name="contractOnlyId" placeholder="请填写门店名称" readonly/>
                        <van-field label="品牌名称" v-model="item.brandName" name="brandName" placeholder="请填写品牌名称" readonly />
                        <van-field label="业态分类" v-model="item.businessFormatName" name="businessFormat" placeholder="请选择业态分类" readonly />
                        <van-field label="计租面积" v-model="item.businessArea" name="businessArea" placeholder="请填写计租面积" :readonly="is24Hours || item.contractState==-1 || item.contractState>3" />
                        <van-field label="招采对接人" required v-model="item.recruitmentLiaison" name="recruitmentLiaison" placeholder="请填写招采对接人" :rules="[{ required: true, message: '请填写招采对接人' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                        <van-field label="品牌对接人" required v-model="item.brandLiaison" name="brandLiaison" placeholder="请填写品牌对接人" :rules="[{ required: true, message: '请填写品牌对接人' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                        <van-field name="advertisingSpaceFlag" label="是否有广告位" required :rules="[{ required: true, message: '请选择是否有广告位' }]">
                            <template #input>
                                <van-radio-group v-model="item.advertisingSpaceFlag" direction="horizontal" :readonly="is24Hours || item.contractState==-1 || item.contractState>3">
                                <van-radio name="0">否</van-radio>
                                <van-radio name="1">是</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-field label="广告位置及说明" v-model="item.advertisingSpaceExplain" rows="2" autosize type="textarea" placeholder="请填写广告位置及说明" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                        <van-field label="电费标准(元/度)" label-width="7em" required v-model="item.electricityTariffStandard" name="electricityTariffStandard" placeholder="请填写电费标准" :rules="[{ required: true, message: '请填写电费标准' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                        <van-field label="水费标准(元/吨)" label-width="7em" required v-model="item.waterFeeStandard" name="waterFeeStandard" placeholder="请填写水费标准" :rules="[{ required: true, message: '请填写水费标准' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>

                        <van-field label="合同签署情况" v-model="item.contractStateName" name="contractState" placeholder="请填写合同签署情况" readonly/>
                        <van-field label="供应商名称" v-model="item.supplyName" name="waterFeeStandard" placeholder="请填写供应商名称" readonly/>
                        <van-field label="经营类型" required v-model="item.businessTypeName" name="businessType" placeholder="请填写经营类型" readonly :rules="[{ required: true, message: '请填写经营类型' }]"/>
                        <van-field label="楼层位置" required v-model="item.floorLocation" name="floorLocation" placeholder="请填写楼层位置" :rules="[{ required: true, message: '请填写楼层位置' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                        <van-field label="原铺品牌" v-model="item.originalStoreBrand" name="originalStoreBrand" placeholder="请填写原铺品牌" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                        <van-field label="品牌联系方式" required v-model="item.brandContactInformation" name="brandContactInformation" placeholder="请填写品牌联系方式" :rules="[{ required: true, message: '请填写品牌联系方式' },{validator: (value) => /^(0\d{2,3}-\d{7,8}|1[3-9]\d{9})$/.test(value),message: '请输入正确的手机号或电话号码'}]" :readonly="is24Hours || formlist.contractState==-1 || formlist.contractState>3"/>
                        <van-field label="计租时间" required v-model="item.billingDate" is-link readonly name="billingDate" placeholder="请选择计租时间" @click="gettype('billingDate',index)"/>
                        <van-field label="装修免租期" required v-model="item.rentFreePeriod" name="rentFreePeriod" placeholder="请填写装修免租期" :rules="[{ required: true, message: '请填写装修免租期' }]" :readonly="is24Hours || item.contractState==-1 || item.contractState>3">
                            <template #button>天</template>
                        </van-field>
                        <van-field label="交房时间" required v-model="item.deliveryTime" is-link readonly name="deliveryTime" placeholder="请选择交房时间" @click="gettype('deliveryTime',index)" :rules="[{ required: true, message: '请选择交房时间' }]"/>
                        <van-field label="交房特殊约定" v-model="item.deliveryAgreement" rows="2" autosize  type="textarea" placeholder="请填写交房特殊约定" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                        <van-field label="商户计划进场时间" label-width="8em" required v-model="item.entryTime" is-link readonly name="entryTime" placeholder="请选择商户计划进场时间" @click="gettype('entryTime',index)" :rules="[{ required: true, message: '请选择商户计划进场时间' }]"/>
                        <van-field label="进场特殊约定" v-model="item.entryAgreement" rows="2" autosize type="textarea" placeholder="请填写进场特殊约定" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                        <van-field label="其他特殊说明" v-model="item.supplementaryInformation" rows="2" autosize type="textarea" placeholder="请填写其他特殊说明" :readonly="is24Hours || item.contractState==-1 || item.contractState>3"/>
                        <van-calendar title="选择日期" color="#3332B5" v-model="show" @confirm="onConfirmtwo" />
                        <div style="margin: 16px;" v-if="!is24Hours && item.contractState>-1 && item.contractState<=3 && (button.includes('btn_milifeadd') || button.includes('btn_milifeedit'))">
                            <van-button round block type="info" native-type="submit" :loading="btnloading">保存</van-button>
                        </div>
                    </van-form>
                    </div>
                </van-collapse-item>
            </van-collapse>
            <div class="mt20 ma16" v-if="form.lifecycleInfoList.length>0 && (form.lifecycleInfoList[form.lifecycleInfoList.length-1].contractState<1 || form.lifecycleInfoList[form.lifecycleInfoList.length-1].contractState>3) && (button.includes('btn_milifeadd') || button.includes('btn_milifeedit'))">
                <van-button type="info" size="small" color="#3332B5" text-type icon="add" @click="gopage()">增加变更</van-button>
            </div>
            <van-collapse v-model="activeNames" v-if="sid!='' && sid!=-1">
                <van-collapse-item title="生命周期进度" name="1" v-if="button.includes('btn_milifeviewdetail')">
                    <van-cell-group class="noline rebox bhbj">
                        <van-cell :class="item.confirmFlag==1?'lv':'jg'" :title="getprosub(item.lifecycleProgressSub)" :value="item.confirmFlag==1?'已完成':'待完成'"  v-for="(item,index) in formlist.progressList" :key="index"/>
                    </van-cell-group>
                </van-collapse-item>
                <div v-for="(item,index) in formlist.progressList" :key="index">
                    <van-collapse-item title="首期费用收缴" :name="(Number(index)+2)" v-if="item.lifecycleProgressSub==21 && button.includes('btn_milifeviewdetail')">
                        <div class="row-flex" slot="title">
                        首期费用收缴
                        <span v-if="(item.confirmTime!='' && item.confirmTime!=null)" class="lan">{{gettime(item.confirmTime)}}</span>
                    </div>
                        <van-grid border :row-num="8/4">
                            <van-grid-item text="" />
                            <van-grid-item text="收付款单号" />
                            <van-grid-item text="应付金额(元)" />
                            <van-grid-item text="已付金额(元)" />
                        </van-grid>
                        <van-grid border :row-num="8/4" v-for="(otem,nindex) in formlist.paymentItemList" :key="nindex">
                            <van-grid-item :text="otem.costName" />
                            <van-grid-item :text="otem.paymentReceiptNo" />
                            <van-grid-item :text="otem.payableAmount" />
                            <van-grid-item :text="otem.amountPaid" />
                        </van-grid>
                        <van-cell-group class="noline rebox m-t-15">
                            <van-cell title="应收总金额（元）" :value="yamount+'元'" />
                            <van-cell title="实收总金额（元）" :value="samount+'元'" />
                            <van-cell title="未收总金额（元）" :value="wamount+'元'" />
                        </van-cell-group>
                        <van-divider :margin="12" />
                        <div class="dlist">
                            <div class="m-b-15">
                                <van-cell-group class="noline rebox" v-for="(otem,nindex) in item.approvalProcessList" :key="nindex">
                                    <van-cell class="tit" title="钉钉审批号" :value="otem.businessId" />
                                    <van-cell title="备注" :value="otem.memo" />
                                    <van-cell title="操作人" :value="otem.operatorName" />
                                    <van-cell title="操作时间" :value="otem.operationTime" />
                                </van-cell-group>
                                <van-divider/>
                                <van-cell-group class="noline rebox wval" v-for="(otem,nindex) in item.voucherList" :key="nindex">
                                    <van-cell title="凭证图片">
                                        <template #default>
                                            <van-uploader v-model="otem.voucher" :deletable="false" />
                                        </template>
                                    </van-cell>
                                    <van-cell title="备注" :value="otem.memo" />
                                    <van-cell title="操作人" :value="otem.operatorName" />
                                    <van-cell title="操作时间" :value="otem.operationTime" />
                                </van-cell-group>
                            </div>
                            <van-divider :margin="12" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3"/>
                            <div class="mauto" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3">
                                <van-button type="info" size="small" color="#3332B5" @click="getding(item.lifecycleProgressSub)">特批通过</van-button>
                            </div>
                        </div>
                    </van-collapse-item>
                
                    <van-collapse-item title="当前工程作业" :name="(Number(index)+2)" v-if="item.lifecycleProgressSub==31">
                        <div class="row-flex" slot="title">
                        当前工程作业
                        <span v-if="(item.operationTime!='' && item.operationTime!=null)" class="lan">{{gettime(item.operationTime)}}</span>
                    </div>
                        <van-cell-group class="shadow" v-for="(otem,nindex) in formlist.engineeringList" :key="nindex">
                            <van-cell title="工程要求" :value="otem.merchantRequirements" />
                            <van-cell title="招商操作人" :value="otem.investmentOperatorName" />
                            <van-cell title="招商操作时间" :value="otem.investmentOperationTime" />
                            <van-cell title="工程反馈" :value="otem.engineeringFeedback" />
                            <van-cell title="工程操作人" :value="otem.engineeringOperatorName" />
                            <van-cell title="工程操作时间" :value="otem.engineeringOperationTime" />
                            <div class="mt20 mb20" v-if="(otem.engineeringOperationTime=='' || otem.engineeringOperationTime==null) && formlist.contractState>=1 && formlist.contractState<=3">
                                <van-button type="info" size="small" color="#3332B5" @click="addFeedback(otem)">确认完成</van-button>
                            </div>
                        </van-cell-group>
                        <van-empty
                        v-if="formlist.engineeringList.length==0"
                        class="custom-image"
                        image="https://maindata-1319309047.cos.ap-beijing.myqcloud.com/image/2025/07/30/1753843734091866.png"
                        description="暂无内容"/>
                        <div class="mt20" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3">
                            <van-button type="info" size="small" color="#3332B5" @click="addmerchant()" v-if="item.confirmFlag!=1">增加一行</van-button>
                            <van-button type="info" size="small" color="#3332B5" @click="getlife(index)" v-if="item.confirmFlag!=1">进度确认</van-button>
                        </div>
                    </van-collapse-item>
                    <van-collapse-item :title="getprosub(item.lifecycleProgressSub)+'确认'" :name="(Number(index)+2)" v-if="((item.lifecycleProgressSub>=41 && item.deliveryTime!='' && item.deliveryTime!=null) || item.lifecycleProgressSub==61 || item.lifecycleProgressSub==44) && button.includes('btn_milifeviewdetail')">
                    <div class="row-flex" slot="title">
                        {{getprosub(item.lifecycleProgressSub)}}确认完成
                        <span v-if="(item.deliveryTime!='' && item.deliveryTime!=null) || (item.confirmTime!='' && item.confirmTime!=null)" :class="compareTimes(item.confirmTime,item.deliveryTime)?'red':!compareTimes(item.confirmTime,item.deliveryTime) && (item.confirmTime=='' || item.confirmTime==null)?'':'lan'">{{gettime(item.confirmTime || item.deliveryTime)}}</span>
                    </div>
                        <van-cell-group class="cnoline" v-if="item.lifecycleProgressSub!=61">
                            <van-cell :title="'预计'+getprosubtime(item.lifecycleProgressSub)+'时间'" :value="gettime(item.deliveryTime)" />
                            <van-field class="hbj" v-model="item.deliveryMemo" readonly rows="4" autosize label="交付特殊约定" type="textarea" placeholder="交付特殊约定"/>
                            <div v-if="item.lifecycleProgressSub!=46">
                                <van-cell required :title="getprosubsjtime(item.lifecycleProgressSub)" is-link :value="gettime(item.confirmTime)" @click="getdata(index,'confirmTime')" />
                                <van-field class="hbj" v-model="item.delayReason" rows="4" autosize label="延后原因" type="textarea" :readonly="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && ((item.lifecycleProgressSub==42 && button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && button.includes('btn_milifeopen')))?false:true" show-word-limit placeholder="延后原因"/>
                                <van-field required :label="getprosubdesc(item.lifecycleProgressSub)" label-width="75px" v-if="item.lifecycleProgressSub==41 || item.lifecycleProgressSub==45 || item.lifecycleProgressSub==46">
                                    <template #input>
                                        <van-uploader v-model="item.attachmenttwo" :max-count="1" :disabled="item.confirmFlag==1 || formlist.contractState==-1 || formlist.contractState>3 || ((item.lifecycleProgressSub==42 && !button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && !button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && !button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && !button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && !button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && !button.includes('btn_milifeopen')))?true:false" :deletable="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && ((item.lifecycleProgressSub==42 && button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && button.includes('btn_milifeopen')))?true:false" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index,'attachment')" :after-read="(file, detail) => afterRead(file, detail,index,'attachment')" />
                                    </template>
                                </van-field>
                                <van-field label="图片" label-width="75px">
                                    <template #input>
                                        <van-uploader v-model="item.imgListtwo" :disabled="item.confirmFlag==1 || formlist.contractState==-1 || formlist.contractState>3 || ((item.lifecycleProgressSub==42 && !button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && !button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && !button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && !button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && !button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && !button.includes('btn_milifeopen')))?true:false" :deletable="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && ((item.lifecycleProgressSub==42 && button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==46 && button.includes('btn_milifepaper')) || (item.lifecycleProgressSub==51 && button.includes('btn_milifeopen')))?true:false" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index,'')" :after-read="(file, detail) => afterRead(file, detail,index,'')" />
                                    </template>
                                </van-field>
                                <van-field label="开业验收表" label-width="75px" v-if="item.lifecycleProgressSub==51">
                                    <template #input>
                                        <div  v-if="item.attachment=='' || item.attachment==null">
                                            <van-uploader v-model="item.attachmenttwo" :max-count="1" accept="image/*,.xls,.xlsx"  :before-read="beforeRead1" @delete="(file, detail) => deleteImg(file, detail,index,'attachment')" :after-read="(file, detail) => afterRead(file, detail,index,'attachment')"> 
                                                <van-button icon="plus" type="primary" size="small">上传文件</van-button>
                                            </van-uploader>
                                        </div>
                                        <div style="width:100%" class="row-between" v-else>
                                            <van-button type="primary" size="small" @click="downfile(item)">下载文件</van-button>
                                            <van-icon name="close" @click="godel(item)" size="2em" v-if="item.confirmFlag!=1"/>
                                        </div>
                                    </template>
                                </van-field>
                                <van-field label=" " label-width="75px" v-if="item.lifecycleProgressSub==51 && (item.attachment=='' || item.attachment==null)">
                                    <template #input>
                                        <div class="tips">只能上传.xls,.xlsx文件</div>
                                    </template>
                                </van-field>
                                
                            </div>
                            <div v-else>
                                <van-cell required :title="getprosubsjtime(item.lifecycleProgressSub)" is-link :value="gettime(item.confirmTime)" @click="getdatathree(index,'confirmTime')" />
                                <van-field class="hbj" v-model="item.delayReason" rows="4" autosize label="延后原因" type="textarea" :readonly="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || !button.includes('btn_milifepaper') || item.isattachment?true:false" show-word-limit placeholder="延后原因"/>
                                <van-field required :label="getprosubdesc(item.lifecycleProgressSub)" label-width="75px" v-if="item.lifecycleProgressSub==46">
                                    <template #input>
                                        <van-uploader v-model="item.attachmenttwo" :max-count="1" :disabled="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || item.isattachment || !button.includes('btn_milifepaper')?true:false" :deletable="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || !item.isattachment || !button.includes('btn_milifepaper')?true:false" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index,'attachment')" :after-read="(file, detail) => afterRead(file, detail,index,'attachment')" />
                                    </template>
                                </van-field>
                                <van-field label="图片" label-width="75px">
                                    <template #input>
                                        <van-uploader v-model="item.imgListtwo" :disabled="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || item.isattachment || !button.includes('btn_milifepaper')?true:false" :deletable="formlist.contractState==-1 || formlist.contractState>3 || item.confirmFlag==0 || !item.isattachment || !button.includes('btn_milifepaper')?true:false" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index,'')" :after-read="(file, detail) => afterRead(file, detail,index,'')" />
                                    </template>
                                </van-field>
                            </div>
                            <van-cell title="操作人" :value="item.operatorName" />
                            <van-cell title="操作时间" :value="item.operationTime" />
                            <div class="mauto" v-if="item.lifecycleProgressSub!=41 && item.lifecycleProgressSub!=46 && item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && ((item.lifecycleProgressSub==42 && button.includes('btn_milifebuild')) || (item.lifecycleProgressSub==43 && button.includes('btn_milifeprocess')) || (item.lifecycleProgressSub==44 && button.includes('btn_milifemarch')) || (item.lifecycleProgressSub==45 && button.includes('btn_milifecomplete')) || (item.lifecycleProgressSub==51 && button.includes('btn_milifeopen')))">
                                <van-button :loading="loading" type="info" size="small" color="#3332B5" @click="gosubmit(index)" v-if="item.confirmFlag!=1">确认</van-button>
                            </div>
                        </van-cell-group>
                         <div v-if="item.lifecycleProgressSub==45 && formlist.inspectionList && formlist.inspectionList!=null && formlist.inspectionList.length>0">
                            <van-divider />
                            <van-cell title="竣工验收记录" />
                            <van-steps direction="vertical" :active="formlist.inspectionList.length" active-color="#3332B5">
                                <van-step v-for="(ntem,mindex) in formlist.inspectionList" :key="mindex">
                                    <div>商户实际完工时间：{{ntem.confirmTime}}</div>
                                    <div>延后原因：{{ntem.delayReason}}</div>
                                    <div>图片：<van-uploader v-model="otem.imgUrlListtwo" :deletable="false" /></div>
                                    <div>竣工验收表：<van-uploader v-model="otem.attachmentListtwo" :deletable="false" /></div>
                                    <div>操作人：{{ntem.operatorName}}</div>
                                    <div>操作时间：{{ntem.operationTime}}</div>
                                </van-step>
                            </van-steps>
                        </div>
                        <div v-if="item.lifecycleProgressSub==41">
                            <van-divider :margin="12" />
                            <van-cell-group class="cnoline" v-for="(otem,nindex) in formlist.openingPlanTimeList" :key="nindex">
                                <van-cell required :title="getprosubtime(otem.lifecycleProgressSub)+'时间'" is-link :value="gettime(otem.scheduledTime)" @click="getdatatwo(index,nindex,'scheduledTime')" />
                                <van-field class="hbj" v-model="otem.memo" rows="4" autosize :label="getprosubtime(otem.lifecycleProgressSub)+'备注'" type="textarea" :readonly="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && button.includes('btn_milifehouse')?false:true" show-word-limit :placeholder="getprosubtime(otem.lifecycleProgressSub)+'备注'"/>
                            </van-cell-group>
                            <div class="mauto" v-if="formlist.contractState>=1 && formlist.contractState<=3 && item.confirmFlag!=1 && button.includes('btn_milifehouse')">
                                <van-button type="info" size="small" color="#3332B5" @click="gosubmit(index)" v-if="item.confirmFlag!=1">确认</van-button>
                            </div>
                        </div>
                        <div v-if="item.lifecycleProgressSub==46">
                            <div class="dlist">
                                <div class="m-b-15">
                                    <van-cell-group class="noline rebox" v-for="(otem,nindex) in item.approvalProcessList" :key="nindex">
                                        <van-cell class="tit" title="钉钉审批号" :value="otem.businessId" />
                                        <van-cell title="备注" :value="otem.memo" />
                                        <van-cell title="操作人" :value="otem.operatorName" />
                                        <van-cell title="操作时间" :value="otem.operationTime" />
                                    </van-cell-group>
                                </div>
                                <van-divider :margin="12" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3"/>
                                <div class="mauto" v-if="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3">
                                    <van-button type="info" size="small" color="#3332B5" @click="getding(item.lifecycleProgressSub)">特批通过</van-button>
                                </div>
                            </div>
                            <div class="mauto" v-if="formlist.contractState>=1 && formlist.contractState<=3 && item.confirmFlag==1 && !item.isattachment && button.includes('btn_milifepaper')">
                                <van-button type="info" size="small" color="#3332B5" @click="gosubmit(index)">确认</van-button>
                            </div>
                        </div>
                        <van-cell-group class="cnoline" v-if="item.lifecycleProgressSub==61">
                            <van-cell required :title="getprosubtime(item.lifecycleProgressSub)+'时间'" is-link :value="gettime(item.confirmTime)" @click="getdata(index,'confirmTime')" />
                            <van-field class="hbj" v-model="item.deliveryMemo" rows="4" autosize label="备注" type="textarea" :readonly="item.confirmFlag!=1 && formlist.contractState>=1 && formlist.contractState<=3 && button.includes('btn_milifeleave')?false:true" show-word-limit placeholder="备注"/>
                            <van-cell title="操作人" :value="item.operatorName" />
                            <van-cell title="操作时间" :value="item.operationTime" />
                            <div class="mauto" v-if="formlist.contractState>=1 && formlist.contractState<=3 && item.confirmFlag!=1 && button.includes('btn_milifeleave')">
                                <van-button :loading="loading" type="info" size="small" color="#3332B5" @click="gosubmit(index)" v-if="item.confirmFlag!=1">确认</van-button>
                            </div>
                        </van-cell-group>
                        
                    </van-collapse-item>
                </div>
            </van-collapse>
        </div>
        <van-calendar title="选择日期" :min-date="minDate" color="#3332B5" v-model="show" @confirm="onConfirm" />
        <van-dialog v-model="showoper" title="温馨提示" show-cancel-button confirmButtonColor="#3332B5" :lazy-render="false" @confirm="getlife">
            <p>操作人：{{uname}}</p>
            <p>操作时间：{{operationTime}}</p>
        </van-dialog>

        <van-dialog v-model="showoperwg" title="注意" show-cancel-button confirmButtonColor="#3332B5" :lazy-render="false" @confirm="getlife">
            <p>最终验收后将无法再再次进行验收</p>
        </van-dialog>

        <van-popup v-model="showtp" position="center" :close-on-click-overlay="false" :round="true" :closeable="true" :style="{ width: '90%' }">
            <van-form @submit="gettp">
                <van-cell title="工程要求"/>
                <van-field
                    class="hbj" 
                    v-model="merchantRequirements"
                    rows="4" autosize name="工程要求" label="" type="textarea" show-word-limit placeholder="工程要求"
                    :rules="[{ required: true, message: '请填写工程要求' }]"/>
                <div style="margin: 16px;">
                    <van-button round block type="info" color="#3332B5" native-type="submit">提交</van-button>
                </div>
                </van-form>
        </van-popup>
        <van-popup v-model="showback" position="center" :close-on-click-overlay="false" :round="true" :closeable="true" :style="{ width: '90%' }">
            <van-form @submit="getFeedback">
                <van-cell title="工程反馈"/>
                <van-field
                    class="hbj" 
                    v-model="engineeringFeedback"
                    rows="4" autosize name="工程反馈" label="" type="textarea" show-word-limit placeholder="工程反馈"
                    :rules="[{ required: true, message: '请填写工程反馈' }]"/>
                    <van-field name="radio" label="是否确认完成">
                        <template #input>
                            <van-radio-group v-model="engineeringCompleteFlag" direction="horizontal">
                            <van-radio name="0">否</van-radio>
                            <van-radio name="1">是</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                <div style="margin: 16px;">
                    <van-button round block type="info" color="#3332B5" native-type="submit">提交</van-button>
                </div>
                </van-form>
        </van-popup>
        <van-popup v-model="showding" position="center" :close-on-click-overlay="false" :round="true" :closeable="true" :style="{ width: '90%' }">
            <div style="height:40px;"></div>
                <van-form @submit="getupding" v-if="lifecycleProgressSub!=21">
                    <van-field
                        v-model="businessId"
                        name="钉钉审批号"
                        label="钉钉审批号"
                        placeholder="钉钉审批号"
                        :rules="[{ required: imageList.length==0?true:false, message: '请填写钉钉审批号' }]"/>
                    <van-cell title="备注"/>
                    <van-field
                        class="hbj" 
                        v-model="memo"
                        rows="4" autosize name="备注" label="" type="textarea" show-word-limit placeholder="备注"/>
                        
                    <div class="ma16">
                        <van-button round block type="info" color="#3332B5" native-type="submit">提交</van-button>
                    </div>
                </van-form>
                <van-form v-else>
                    <van-field
                        v-model="businessId"
                        name="钉钉审批号"
                        label="钉钉审批号"
                        placeholder="钉钉审批号"
                        :rules="[{ required: imageList.length==0?true:false, message: '请填写钉钉审批号' }]"/>
                    <van-cell title="备注"/>
                    <van-field
                        class="hbj" 
                        v-model="memo"
                        rows="4" autosize name="备注" label="" type="textarea" show-word-limit placeholder="备注"/>
                    <van-field label="凭证图片" name="凭证图片" label-width="60px" :rules="[{ required: businessId==''?true:false, message: '请上传凭证图片' }]">
                        <template #input>
                            <van-uploader v-model="imageListtwo" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,'','imageList')" :after-read="(file, detail) => afterRead(file, detail,'',imageList)" />
                        </template>
                    </van-field>
                    <van-field
                        class="hbj" 
                        v-model="voucherMemo"
                        rows="4" autosize name="凭证备注" label="" type="textarea" show-word-limit placeholder="备注"/>
                    <div class="ma16 row-between">
                        <van-button round block type="info" color="#3332B5" @click="getupjd(0)">保存</van-button>
                        <div class="w10"></div>
                        <van-button round block type="info" color="#3332B5" @click="getupjd(1)">确认进度</van-button>
                    </div>
                </van-form>
        </van-popup>
        <van-popup v-model="showpop" :style="{ width: '90%' }" :round="true" :close-on-click-overlay="false">
            <div class="wshop">
                <van-form  :show-error-message="false" :scroll-to-error="true" @submit="gopage">
                    <van-field label="门店" v-model="formtwo.shopName" is-link readonly name="shopName" placeholder="请选择门店" :rules="[{ required: true, message: '请选择门店' }]" @click="getshowinit('shopSid')"/>
                    <van-field label="合同号" v-model="formtwo.contractNo" is-link readonly name="contractNo" placeholder="请选择合同编码" :rules="[{ required: true, message: '请选择合同编码' }]" @click="getshowinit('contractNo')"/>
                    <div class="btnfoot">
                        <van-button round block type="info" native-type="submit">确认</van-button>
                    </div>
                </van-form>
            </div>
        </van-popup>
        <van-action-sheet v-model="showshop" :title="'请选择'+inittype=='shopSid'?'门店':'合同'">
            <van-search v-model="keyword" show-action placeholder="请输入搜索关键词" @search="onSearch" @cancel="onCancel" />
            <div class="scroll">
                <van-cell-group>
                    <van-cell v-for="(item,index) in showlist" :key="index" :title="item.text" @click="getval(item)"/>
                </van-cell-group>
            </div>
        </van-action-sheet>
        <van-dialog v-model="jdshow" title="是否确认首期费用收缴模块进度" show-cancel-button confirmButtonColor="#3332B5" :lazy-render="false" @confirm="getupdingjd">
        </van-dialog>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Dialog } from 'vant';
import COS from 'cos-js-sdk-v5';
import * as Minio from 'minio';
import axios from "axios";
import * as imageConversion from 'image-conversion';
import { min } from 'moment';
export default {
    name: 'lifecycle',
    components: {
        [Dialog.Component.name]: Dialog.Component,
    },
    data () {
        return {
            activeNames: ['1'],
            oneactive:['1'],
            button:this.$route.params.button.split(','),
            token:this.$route.params.token,
            sid:this.$route.params.sid,
            uid:this.$route.params.uid,
            uname:this.$route.params.uname,
            form:{
                lifecycleInfoList:[],
            },
            formlist:'',
            show:false,
            index:0,
            prop:'',
            type:'',
            loading:false,
            showoper:false,
            showoperwg:false,
            operatorName:'',
            operationTime:'',
            showtp:false,
            merchantRequirements:'',
            engineeringFeedback:'',
            engineeringCompleteFlag:'',
            yamount:0,
            samount:0,
            wamount:0,
            minioClient: null,
            selectedFile: null,
            fksid:'',
            showback:false,
            showding:false,
            businessId:'',
            memo:'',
            show:false,
            showtype:'',
            btnloading:false,
            showshop:false,
            keyword:'',
            showpop:false,
            allshoplist:[],
            allcontractlist:[],
            shoplist:[],
            contractlist:[],
            showlist:[],
            formtwo:{
                shopSid:'',
                shopName:'',
                contractNo:'',
                contractOnlyId:'',
            },
            inittype:'',
            is24Hours:false,
            lifecycleProgressSub:'',
            cos:'',
            voucherMemo:'',
            imageList:[],
            imageListtwo:[],
            confirmState:0,
            jdshow:false,
            minDate: new Date(2010, 0, 1),
            findex:'',
        }
    },
    created(){
        if(this.sid!='' && this.sid!=-1){
            this.getdetail()
            // this.getlist()
        }else{
            document.title = '新建租务管理' 
            this.getinit()
            this.showpop=true
        }
    },
    mounted(){
        this.getlifekey()
    },
    methods:{
        getlifekey(){
            let that=this
            that.$axios.get(process.env.API_HOST+"maindata/applets/lifecycle/temporaryKey?prefix=lifecycle",{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.cos=new COS({
                        getAuthorization: async function (options, callback) {
                            callback({
                                TmpSecretId: res.data.data.tmpSecretId,
                                TmpSecretKey: res.data.data.tmpSecretKey,
                                SecurityToken: res.data.data.sessionToken,
                                StartTime: res.data.data.startTime, 
                                ExpiredTime: res.data.data.expiredTime, 
                                ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
                            });
                        }
                    });
                }
            }).catch((error) =>{
            });
        },
        godel(item){
            item.attachment=''
            item.attachmenttwo=[]
        },
        downfile(item){
            let url = item.attachmenttwo[0].url;
            let link = document.createElement('a'); 
            link.href = url; 
            link.download = '验收表.xlsx';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click(); 
            document.body.removeChild(link);
        },
        getcontract(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"maindata/vue/contract/info/page?pageNo=1&pageSize=1&contractNo="+that.formtwo.contractNo,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.formtwo.contractOnlyId=res.data.data.list[0].contractOnlyId
                }
            }).catch((error) =>{
            });
        },
        gopage(){
            let that=this
            that.showpop=false
            let contractSid=that.form.lifecycleInfoList.length>0?that.form.lifecycleInfoList[that.form.lifecycleInfoList.length-1].contractSid:''
            contractSid=contractSid || ''
            console.log('ididi----',contractSid)
            console.log(that.form.lifecycleInfoList)
            that.$axios.get(process.env.API_HOST+"maindata/applets/lifecycle/contract?contractOnlyId="+that.formtwo.contractOnlyId+"&shopSid="+that.formtwo.shopSid+'&contractSid='+contractSid,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    let data=res.data.data
                    let formtwo=this.form.lifecycleInfoList.length>0?this.form.lifecycleInfoList[this.form.lifecycleInfoList.length-1]:''
                    that.form.lifecycleInfoList.push({
                        contractState:data.contractState || '',
                        contractStateName:data.contractState==1?'未审核':data.contractState==2?'待生效':data.contractState==3?'已生效':data.contractState==4?'到期':data.contractState==5?'终止':data.contractState==6?'变更终止':data.contractState==-1?'作废':'',
                        advertisingSpaceExplain: data.advertisingSpaceExplain || (formtwo!=''?formtwo.advertisingSpaceExplain:''),
                        advertisingSpaceFlag: data.advertisingSpaceFlag || (formtwo!=''?formtwo.advertisingSpaceFlag:''),
                        billingDate: data.billingDate || (formtwo!=''?formtwo.billingDate:''),
                        brandContactInformation: data.brandContactInformation || (formtwo!=''?formtwo.brandContactInformation:''),
                        brandLiaison: data.brandLiaison || (formtwo!=''?formtwo.brandLiaison:''),
                        contractNo: data.contractNo || '',
                        contractOnlyId:data.contractOnlyId || '',
                        contractSid:data.contractSid || '',
                        supplySid:data.supplySid || '',
                        supplyName:data.supplyName || '',
                        brandSid:data.brandSid || '',
                        brandName:data.brandName || '',
                        businessType:data.businessType|| '',
                        businessTypeName:data.businessType==1?'自营':data.businessType==2?'底价寄售':data.businessType==3?'联营':data.businessType==4?'租赁':data.businessType==5?'分成寄售':data.businessType==6?'MAXX联营':'',
                        businessFormat:data.businessFormat || '',
                        businessFormatName:data.businessFormat==1?'餐饮类':data.businessFormat==2?'购物类':data.businessFormat==3?'联营工厂':data.businessFormat==4?'联营统装':data.businessFormat==5?'配套类':data.businessFormat==6?'娱乐体验类':data.businessFormat==7?'MAXX':'',
                        businessArea:data.businessArea || (formtwo!=''?formtwo.businessArea:''),
                        deliveryAgreement: data.deliveryAgreement || (formtwo!=''?formtwo.deliveryAgreement:''),
                        deliveryTime: data.deliveryTime || (formtwo!=''?formtwo.deliveryTime:''),
                        electricityTariffStandard: data.electricityTariffStandard || (formtwo!=''?formtwo.electricityTariffStandard:''),
                        entryAgreement: data.entryAgreement || (formtwo!=''?formtwo.entryAgreement:''),
                        entryTime: data.entryTime || (formtwo!=''?formtwo.entryTime:''),
                        floorLocation: data.floorLocation || (formtwo!=''?formtwo.floorLocation:''),
                        originalStoreBrand: data.originalStoreBrand || (formtwo!=''?formtwo.originalStoreBrand:''),
                        recruitmentLiaison: data.recruitmentLiaison || (formtwo!=''?formtwo.recruitmentLiaison:''),
                        rentFreePeriod: data.rentFreePeriod || (formtwo!=''?formtwo.rentFreePeriod:''),
                        shopSid: data.shopSid,
                        shopName: data.shopName,
                        supplementaryInformation: formtwo!=''?formtwo.waterFeeStandard:'',
                        waterFeeStandard: data.waterFeeStandard || (formtwo!=''?formtwo.waterFeeStandard:''),
                    })
                    if(this.sid=='' || this.sid==-1){
                        this.oneactive=['1']
                    }
                    //if(this.sid=='' || this.sid==-1){
                    //    this.form=that.form.lifecycleInfoList[that.form.lifecycleInfoList.length-1]
                    //}
                    // that.formlist=that.form.lifecycleInfoList[that.form.lifecycleInfoList.length-1]
                    that.contractState=res.data.contractState || ''
                    that.is24Hours=false
                }else{
                    that.$toast(res.data.message)
                }
            }).catch((error) =>{
            });
        },
        getval(item){
            if(this.inittype=='shopSid'){
                this.formtwo.shopSid=item.value
                this.formtwo.shopName=item.text
                this.getinit()
            }else{
                this.formtwo.contractNo=item.value
                this.getcontract()
            }
            this.showshop=false
        },
        getinit(){
            let that=this;
            that.$axios.get(process.env.API_HOST+"maindata/vue/contract/info/filterItemList?shopSid="+that.formtwo.shopSid,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.allshoplist = res.data.data.shopList || []
                    that.allcontractlist = res.data.data.contractList || []
                }
            }).catch((error) =>{
            });
        },
        getshowinit(type){
            this.inittype=type
            this.keyword=''
            this.showlist=JSON.parse(JSON.stringify(type=='shopSid'?this.allshoplist:this.allcontractlist))
            this.showshop=true
        },
        onCancel(){

        },
        onSearch(){
            let alllist=JSON.parse(JSON.stringify(this.inittype=='shopSid'?this.allshoplist:this.allcontractlist))
            this.showlist=alllist.filter(item => item.text.includes(this.keyword))
        },
        gettype(showtype,index){
            if(this.is24Hours || this.form.lifecycleInfoList[index].contractState==-1 || this.form.lifecycleInfoList[index].contractState>3) return
            this.findex=index
            this.showtype=showtype
            this.show=true
        },
        onConfirmtwo(date) {
            this.show = false;
            this.form.lifecycleInfoList[this.findex][this.showtype] = this.formatDate(date);
        },
        editlifesave(row){
            let that=this;
            if(row.confirmTime=='' || row.confirmTime==null){
                this.$toast('请选择'+this.getprosubsjtime(row.lifecycleProgressSub));
                return
            }
            if(row.attachment=='' || row.attachment==null){
                this.$dialog.alert({
                    message:'请上传'+this.getprosubdesc(row.lifecycleProgressSub)
                })
                return
            }
            that.btnloading=true
            let form={
                attachmentList:row.attachment.split(','),
                confirmTime:row.confirmTime,
                delayReason:row.delayReason,
                imgUrlList:row.imgList || [],
                progressSid:row.sid,
            }
            that.$axios.post(process.env.API_HOST+"maindata/applets/lifecycle/inspection",form,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.btnloading=false
                    that.$toast.success('保存成功');
                }else{
                    that.btnloading=false
                    that.$toast.fail(res.data.message);
                }
            })
        },
        getSubmit(values){
            let that=this
            that.btnloading=true
            let form=that.form.lifecycleInfoList[that.form.lifecycleInfoList.length-1]
            if(!form.sid || form.sid=='' || form.sid==-1){
                that.$axios.post(process.env.API_HOST+"maindata/applets/lifecycle",form,{
                    headers:{
                        userTicket:that.token
                    }
                }).then((res) => {
                    if(res.data.state==200){
                        that.btnloading=false
                        that.$toast.success('保存成功');
                        wx.miniProgram.getEnv(function (res) {
                            if (res.miniprogram) {
                                wx.miniProgram.reLaunch({
                                    url:'/pages/index/index?type=showtype',// 指定跳转至小程序页面的路径
                                    success: (res) => {
                                        // alert(res)
                                        console.log(res);   // 页面跳转成功的回调函数
                                    },
                                    fail: (err) => {
                                        console.log(err);   // 页面跳转失败的回调函数
                                    }
                                });
                            }
                        });
                    }else{
                        that.$toast.fail(res.data.message);
                    }
                })
            }else{
                that.$axios.put(process.env.API_HOST+"maindata/applets/lifecycle",form,{
                    headers:{
                        userTicket:that.token
                    }
                }).then((res) => {
                    if(res.data.state==200){
                        that.getlist()
                        that.btnloading=false
                        that.$toast.success('保存成功');
                    }else{
                        that.$toast.fail(res.data.message);
                    }
                })
            } 
        },
        compareTimes(time1,time2) {
            let date1 = time1!='' && time1!=null?new Date(time1):new Date();
            let date2 = new Date(time2);
            let ismax=false
            if (date1 < date2) {
                ismax=false
            } else if (date1 > date2) {
                ismax=true
            } else {
                ismax=false
            }
            return ismax
        },
        getding(lifecycleProgressSub){
            this.businessId=''
            this.memo=''
            this.lifecycleProgressSub=lifecycleProgressSub
            this.showding=true
        },
        getupjd(val){
            console.log("这里1")
            this.confirmState=val
            this.getupding()
        },
        getupding(){
            let that=this;
            if(that.businessId=='' && that.imageList.length==0) return
            if(that.confirmState==1){
                that.jdshow=true
                return
            }
            console.log("这里2")
            that.getupdingjd()
        },
        getupdingjd(){
            let that=this;
            let form={
                sid:that.sid,
                businessId:that.businessId,
                lifecycleProgressSub:that.lifecycleProgressSub,
                memo:that.memo,
                imageList:that.imageList,
                voucherMemo:that.voucherMemo,
                confirmState:that.confirmState,
            }
            that.$axios.post(process.env.API_HOST+"maindata/applets/lifecycle/approval",form,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.getlist()
                    that.showding=false
                    that.jdshow=false
                    that.$toast.success('提交成功');
                }else{
                    that.$toast.fail(res.data.message);
                }
            })
        },
        dateNumber(sp=''){
            const date = new Date()
            const  year = date.getFullYear()
            const  month = date.getMonth()>9?date.getMonth()+1:'0'+(date.getMonth()+1)
            const  day = date.getDate();
            return year.toString()+month+day.toString()
        },
        getUUID () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
            })
        },
        // 返回布尔值
        beforeRead(file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
                this.$toast('图片格式不正确');
                return false;
            }
            return new Promise((resolve) => {
                imageConversion.compressAccurately(file, 400).then(res => {
                    let res2= new File([res], file.name, {
                        type: res.type,
                        lastModified: Date.now()
                    });
                    this.selectedFile=res2
                    resolve(res);
                });
            })
        },
        beforeRead1(file){
            let that=this;
            let name=file.name.split('.')
            that.selectedFile=file
            let index=that.formlist.progressList.findIndex(item=>item.lifecycleProgressSub==51)
            if (name[name.length-1] != 'xlsx' && name[name.length-1] != 'xls') {
                that.$toast('文件格式不正确');
                return false;
            }
            const suffixType =that.selectedFile&&that.selectedFile.name?that.selectedFile.name.substr(that.selectedFile.name.lastIndexOf('.')):''
            const UrlName = `lifecycle/${that.dateNumber()}/${that.getUUID()}${suffixType}`
            if (!that.selectedFile) return;
            that.cos.putObject({
                Bucket: 'maindata-1319309047',
                Region: 'ap-beijing',
                Key: UrlName,
                StorageClass: 'STANDARD',
                Body: that.selectedFile,
                onProgress: progressData => {
                console.log(`log- progressData: ${JSON.stringify(progressData)}`)
                // if (progressData.percent) {
                //   that.showProgress = true
                //   that.progress = Math.floor(progressData.percent * 100)
                // }
                }
            }, (err, data) => {
                // console.log(`log- upload data: ${JSON.stringify(data)} ｜ err: ${JSON.stringify(err)}`)
                if (data && data.statusCode === 200) {
                    let uploadResult = 'https://static.xunchen.work/' + UrlName
                    that.formlist.progressList[index].attachment=UrlName
                    that.formlist.progressList[index].attachmenttwo=[{
                        url:uploadResult
                    }]
                    that.$toast('上传成功')
                // that.$emit('complete', uploadResult)
                } else {
                    that.$toast('上传失败')
                    that.formlist.progressList[index].attachmenttwo=[]
                }
            })
        },
        deleteImg(file, detail,index,type) {
            if(type=='attachment'){
                this.formlist.progressList[index].attachment=''
                this.formlist.progressList[index].attachmenttwo=[]
                return
            }
            if(type=='imageList'){
                this.imageList.splice(detail.index, 1)
                this.imageListtwo.splice(detail.index, 1)
                return
            }
            this.formlist.progressList[index].imgListtwo.splice(detail.index, 1)
            that.formlist.progressList[index].imgList.splice(detail.index, 1)
        },
        afterRead(files, detail,index,type) {
            let that=this;
            console.log("这里这里")
            files.status = "uploading";
            files.message = "上传中...";
            const suffixType =that.selectedFile&&that.selectedFile.name?that.selectedFile.name.substr(that.selectedFile.name.lastIndexOf('.')):''
            const UrlName = `lifecycle/${that.dateNumber()}/${that.getUUID()}${suffixType}`
            console.log('selectedFile',!that.selectedFile)
            if (!that.selectedFile) return;
            that.cos.putObject({
                Bucket: 'maindata-1319309047',
                Region: 'ap-beijing',
                Key: UrlName,
                StorageClass: 'STANDARD',
                Body: that.selectedFile,
                onProgress: progressData => {
                console.log(`log- progressData: ${JSON.stringify(progressData)}`)
                // if (progressData.percent) {
                //   that.showProgress = true
                //   that.progress = Math.floor(progressData.percent * 100)
                // }
                }
            }, (err, data) => {
                // console.log(`log- upload data: ${JSON.stringify(data)} ｜ err: ${JSON.stringify(err)}`)
                if (data && data.statusCode === 200) {
                    let uploadResult = 'https://static.xunchen.work/' + UrlName
                    that.$toast('上传成功')
                    files.status = "";
                    if(type=='imageList'){
                        that.imageList.push(UrlName)
                        return
                    }
                    if(type=='attachment'){
                        that.formlist.progressList[index].attachment=UrlName
                        return
                    }
                    that.formlist.progressList[index].imgList.push(UrlName)
                } else {
                    that.$toast('上传失败')
                    files.status = "";
                    if(type=='imageList'){
                        that.imageListtwo.splice(that.imageListtwo.length-1,1)
                        return
                    }
                    if(type=='attachment'){
                        that.formlist.progressList[index].attachmenttwo=[]
                        return
                    } 
                    that.formlist.progressList[index].imgListtwo.splice(that.formlist.progressList[index].imgListtwo.length-1,1)
                }
            })
        },
        addmerchant(){
            this.merchantRequirements=''
            this.showtp=true
        },
        addFeedback(row){
            this.fksid=row.sid
            this.engineeringFeedback=''
            this.engineeringCompleteFlag=''
            this.showback=true
        },
        getFeedback(){
            let that=this;
            let form={
                lifecycleSid:that.sid,
                sid:that.fksid,
                engineeringFeedback:that.engineeringFeedback,
                engineeringCompleteFlag:that.engineeringCompleteFlag,
            }
            that.$axios.post(process.env.API_HOST+"maindata/applets/lifecycle/engineering/feedback",form,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.getlist()
                    that.showback=false
                    that.$toast.success('提交成功');
                }else{
                    that.$toast.fail(res.data.message);
                }
            })
        },
        gettp(){
            let that=this;
            let form={
                lifecycleSid:that.sid,
                merchantRequirements:that.merchantRequirements,
            }
            that.$axios.post(process.env.API_HOST+"maindata/applets/lifecycle/engineering/require",form,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.getlist()
                    that.showtp=false
                    that.$toast.success('提交成功');
                }else{
                    that.$toast.fail(res.data.message);
                }
            })
        },
        editjindu(row){
            let that=this;
            let show=false
            if(that.formlist.engineeringList.length>0){
                that.formlist.engineeringList.filter((item, i) => {
                    if(item.engineeringOperationTime=='' || item.engineeringOperationTime==null){
                        show=true
                    }
                })
            }
            if(show){
                that.$toast('请先确认完成工程作业');
                return
            }
            Dialog.confirm({
                title: '温馨提示',
                message: '工程作业进度是否确认提交',
            }).then(() => {
                let form={
                    confirmFlag:1,
                    sid:row.sid
                }
                that.$axios.put(process.env.API_HOST+"maindata/applets/lifecycle/progress",form,{
                    headers:{
                        userTicket:that.token
                    }
                }).then((res) => {
                    if(res.data.state==200){
                        that.getlist()
                        // that.showtp=false
                        that.$toast.success('提交成功');
                    }else{
                        that.$toast.fail(res.data.message);
                    }
                })
                // on confirm
            }).catch(() => {
                // on cancel
            });
            // 
        },
        getdata(index,prop){
            if(this.formlist.progressList[index].lifecycleProgressSub>=41 && this.formlist.progressList[index].lifecycleProgressSub<=51){
                this.minDate=new Date(Date.now()-2 * 24 * 60 * 60 * 1000)
            }else{
                this.minDate=new Date(2010, 0, 1)
            }
            if(this.formlist.progressList[index].confirmFlag==1 || this.formlist.contractState==-1 || this.formlist.contractState>3 || (this.formlist.progressList[index].lifecycleProgressSub==41 && !this.button.includes('btn_milifehouse')) || (this.formlist.progressList[index].lifecycleProgressSub==42 && !this.button.includes('btn_milifebuild')) || (this.formlist.progressList[index].lifecycleProgressSub==43 && !this.button.includes('btn_milifeprocess')) || (this.formlist.progressList[index].lifecycleProgressSub==44 && !this.button.includes('btn_milifemarch')) || (this.formlist.progressList[index].lifecycleProgressSub==45 && !this.button.includes('btn_milifecomplete')) || (this.formlist.progressList[index].lifecycleProgressSub==46 && !this.button.includes('btn_milifepaper')) || (this.formlist.progressList[index].lifecycleProgressSub==51 && !this.button.includes('btn_milifeopen')) || (this.formlist.progressList[index].lifecycleProgressSub==61 && !this.button.includes('btn_milifeleave'))) return
            this.index=index
            this.prop=prop
            this.type=1
            this.show=true
        },
        getdatathree(index,prop){
            let that=this
            if(that.formlist.progressList[index].lifecycleProgressSub>=41 && that.formlist.progressList[index].lifecycleProgressSub<=51){
                that.minDate=new Date(Date.now()-2 * 24 * 60 * 60 * 1000)
            }else{
                that.minDate=new Date(2010, 0, 1)
            }
            
            if(that.formlist.contractState==-1 || that.formlist.contractState>3 || that.formlist.progressList[index].confirmFlag==0 || that.formlist.progressList[index].isattachment || !that.button.includes('btn_milifepaper')) return
            that.index=index
            that.prop=prop
            that.type=1
            that.show=true
        },
        getdatatwo(sindex,index,prop){
            if(this.formlist.progressList[sindex].confirmFlag==1 || this.formlist.contractState==-1 || this.formlist.contractState>3 || (this.formlist.progressList[sindex].lifecycleProgressSub==41 && !this.button.includes('btn_milifehouse')) || (this.formlist.progressList[sindex].lifecycleProgressSub==42 && !this.button.includes('btn_milifebuild')) || (this.formlist.progressList[sindex].lifecycleProgressSub==43 && !this.button.includes('btn_milifeprocess')) || (this.formlist.progressList[sindex].lifecycleProgressSub==44 && !this.button.includes('btn_milifemarch')) || (this.formlist.progressList[sindex].lifecycleProgressSub==45 && !this.button.includes('btn_milifecomplete')) || (this.formlist.progressList[sindex].lifecycleProgressSub==46 && !this.button.includes('btn_milifepaper')) || (this.formlist.progressList[sindex].lifecycleProgressSub==51 && !this.button.includes('btn_milifeopen')) || (this.formlist.progressList[sindex].lifecycleProgressSub==61 && !this.button.includes('btn_milifeleave'))) return
            this.index=index
            this.prop=prop
            this.type=2
            this.show=true
        },
        formatDate(date) {
            return `${date.getFullYear()}-${ (date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        },
        onConfirm(date) {
            this.show = false;
            if(this.type==1){
                this.formlist.progressList[this.index][this.prop]=this.formatDate(date)
            }else{
                this.formlist.openingPlanTimeList[this.index][this.prop]=this.formatDate(date)
            }
        },
        gosubmit(index){
            let row=this.formlist.progressList[index]
            if(row.confirmTime=='' || row.confirmTime==null){
                this.$toast('请选择'+this.getprosubsjtime(row.lifecycleProgressSub));
                return
            }
            let contime=new Date(row.confirmTime).getTime()
            let deliveryTime=new Date(row.deliveryTime).getTime()
            if(row.lifecycleProgressSub<61 && contime>deliveryTime && (row.delayReason=='' || row.delayReason==null)){
                this.$dialog.alert({
                    message:this.getprosubsjtime(row.lifecycleProgressSub)+'晚于约定时间,请填写延误原因'
                })
                return
            }
            // if(row.lifecycleProgressSub==45){
            //     row.attachment='lifecycle/20260225/e4877d86-ca54-48cc-817d-79c068348b0f.png'
            // }
            if((row.lifecycleProgressSub==41 || row.lifecycleProgressSub==45 || row.lifecycleProgressSub==46) && (row.attachment=='' || row.attachment==null)){
                this.$dialog.alert({
                    message:'请上传'+this.getprosubdesc(row.lifecycleProgressSub)
                })
                return
            }
            let openindex=-1
            if(this.formlist.openingPlanTimeList.length>0){
                this.formlist.openingPlanTimeList.filter((item, i) => {
                    if(item.scheduledTime=='' || item.scheduledTime==null){
                        openindex=i
                    }
                })
            }
            if(row.lifecycleProgressSub==41 && openindex>=0){
                this.$dialog.alert({
                    message:'请选择'+this.getprosubtime(this.formlist.openingPlanTimeList[openindex].lifecycleProgressSub)+'时间'
                })
                return
            }
            this.index=index
            this.operatorName=this.uname
            var date = new Date();
            this.operationTime=this.formatDate(date)
            if(row.lifecycleProgressSub==45){
                this.showoperwg=true
                return
            }
            this.showoper=true
        },
        getlife(index){
            let that = this
            let row=that.formlist.progressList[index || that.index]
            let form={
                attachment:row.attachment || '',
                confirmFlag:1,
                confirmTime:row.confirmTime,
                delayReason:row.delayReason,
                imgUrlList:row.imgList || [],
                memo:row.memo,
                sid:row.sid,
                openingPlanTimeList:that.formlist.openingPlanTimeList
            }
            if(row.lifecycleProgressSub!=41){
                delete form.openingPlanTimeList
            }
            that.$axios.post(process.env.API_HOST+"maindata/applets/lifecycle/progress",form,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.getlist()
                    that.$toast.success('提交成功');
                }else{
                    that.$toast.fail(res.data.message);
                }
            })
        },
        getdetail(){
            let that = this
            that.$axios.get(process.env.API_HOST+"maindata/applets/lifecycle?sid="+that.sid,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    that.formtwo.contractOnlyId=res.data.data.contractOnlyId
                    that.formtwo.shopSid=res.data.data.shopSid
                    that.getlist()
                }
            })
            
        },
        getlist(){
            let that = this
            that.$axios.get(process.env.API_HOST+"maindata/applets/lifecycle/query?shopSid="+that.formtwo.shopSid+'&contractOnlyId='+that.formtwo.contractOnlyId,{
                headers:{
                    userTicket:that.token
                }
            }).then((res) => {
                if(res.data.state==200){
                    let data=res.data.data
                    let flist=data.lifecycleInfoList || []
                    if(flist.length>0){
                        document.title = flist[flist.length-1].lifecycleNo
                        flist.filter((item, i) => {
                            item.contractStateName=item.contractState==1?'未审核':item.contractState==2?'待生效':item.contractState==3?'已生效':item.contractState==4?'到期':item.contractState==5?'终止':item.contractState==6?'变更终止':item.contractState==-1?'作废':''
                            item.businessFormatName=item.businessFormat==1?'餐饮类':item.businessFormat==2?'购物类':item.businessFormat==3?'联营工厂':item.businessFormat==4?'联营统装':item.businessFormat==5?'配套类':item.businessFormat==6?'娱乐体验类':item.businessFormat==7?'MAXX':''
                            item.businessTypeName=item.businessType==1?'自营':item.businessType==2?'底价寄售':item.businessType==3?'联营':item.businessType==4?'租赁':item.businessType==5?'分成寄售':item.businessType==6?'MAXX联营':''
                            item.advertisingSpaceFlag=item.advertisingSpaceFlag!=='' && item.advertisingSpaceFlag!==null && item.advertisingSpaceFlag>=0?item.advertisingSpaceFlag.toString():''
                            item.advertisingSpaceFlagName=item.advertisingSpaceFlag==1?'是':item.advertisingSpaceFlag==0?'否':''
                            item.billingDate=item.billingDate && item.billingDate!='' && item.billingDate!=null?that.gettime(item.billingDate):''
                            item.deliveryTime=item.deliveryTime && item.deliveryTime!='' && item.deliveryTime!=null?that.gettime(item.deliveryTime):''
                            item.entryTime=item.entryTime && item.entryTime!='' && item.entryTime!=null?that.gettime(item.entryTime):''
                        })
                        let mindex= flist.findIndex(item => (item.contractState>0 && item.contractState<=3))
                        mindex=flist.length>0 && mindex<0?flist.length-1:mindex
                        if(mindex>=0){
                            let openingPlanTimeList=flist[mindex].openingPlanTimeList || []
                            if(flist[mindex].progressList.length>0){
                                flist[mindex].progressList.filter((item, i) => {
                                    item.approvalProcessList=[]
                                    item.isattachment=item.attachment!='' && item.attachment!=null?true:false
                                    if(item.lifecycleProgressSub>41 && item.lifecycleProgressSub<61 && openingPlanTimeList.length>0){
                                        let index=openingPlanTimeList.findIndex(otem => otem.lifecycleProgressSub == item.lifecycleProgressSub) 
                                        item.deliveryTime=index>-1?openingPlanTimeList[index].scheduledTime:''
                                        item.deliveryMemo=index>-1?openingPlanTimeList[index].memo:''
                                    }
                                    if(item.lifecycleProgressSub==41){
                                        item.deliveryTime=flist[mindex].deliveryTime
                                        item.deliveryMemo=flist[mindex].deliveryAgreement
                                    } 
                                    if(item.lifecycleProgressSub==44){
                                        item.deliveryTime=flist[mindex].entryTime
                                        item.deliveryMemo=flist[mindex].entryAgreement
                                    } 
                                    item.attachmenttwo=[]
                                    if(item.attachment!='' && item.attachment!=null){
                                        item.attachmenttwo.push({url:'https://static.xunchen.work/'+item.attachment})
                                    }
                                    item.imgListtwo=[]
                                    if (item.imgList && item.imgList.length > 0) {
                                        item.imgList.filter((otem, o) => {
                                            item.imgListtwo.push({url:'https://static.xunchen.work/'+otem.imgUrl})
                                        })
                                    }
                                    if(flist[mindex].approvalProcessList.length>0){
                                        flist[mindex].approvalProcessList.filter((otem, o) => {
                                            if(item.lifecycleProgressSub==otem.approvalType){
                                                item.approvalProcessList.push(otem)
                                            }
                                        }) 
                                    }
                                    if(item.lifecycleProgressSub==21 && item.voucherList && item.voucherList!=null && item.voucherList.length>0){
                                        item.voucherList.filter((otem, o) => {
                                            otem.voucher=[]
                                            if(otem.voucherAttachment.length>0){
                                                otem.voucherAttachment.filter((ttem, t) => {
                                                    otem.voucher.push({
                                                        url:'https://static.xunchen.work/'+ttem.imgUrl,
                                                    })
                                                })
                                            }
                                        })
                                    }  
                                })
                            }
                            if(flist[mindex].paymentItemList.length>0){
                                flist[mindex].paymentItemList.filter((item, i) => {
                                    let payableAmount=item.payableAmount || 0;
                                    let amountPaid=item.amountPaid || 0
                                    that.yamount+=payableAmount
                                    that.samount+=amountPaid
                                    that.wamount=that.yamount-that.samount
                                })
                            }
                            if(flist[mindex].inspectionList.length>0){
                                flist[mindex].inspectionList.filter((item, i) => {
                                item.attachmentListtwo=[]
                                item.imgUrlListtwo=[]
                                if(item.attachment!='' && item.attachment!=null && item.attachment.length!=0){
                                    item.attachmentListtwo.push({
                                        url:'https://static.xunchen.work/'+item.attachment[0],
                                    })
                                }
                                if(item.imgUrlList!='' && item.imgUrlList!=null && item.imgUrlList.length!=0){
                                    item.imgUrlList.filter((otem, o) => {
                                        item.imgUrlListtwo.push({
                                            url:'https://static.xunchen.work/'+otem,
                                        })
                                    })
                                }
                                })
                            }
                            that.formlist=flist[mindex]
                        }
                    }

                    that.form = data
                    that.is24Hours=that.isMoreThan24Hours()
                    console.log('这里这里',that.is24Hours)
                }else {
                    that.$toast(res.data.message)
                }
            })			
        },
        isMoreThan24Hours() {
            const currentTime = new Date(); // 获取当前时间
            const timeDifference = currentTime - new Date(this.formlist.createdTime); // 计算时间差（毫秒）
            const hoursDifference = timeDifference / (1000 * 60 * 60); // 将毫秒转换为小时
            return hoursDifference > 24; // 判断是否大于24小时
        },
        gettime(val){
            return val!='' && val!=null?val.split(' ')[0]:''
        },
        getprosubdesc(val){
            return val==41?'交房确认书':val==45?'竣工验收表':val==46?'营业执照':''
        },
        getprosub(val){
            return val==11?'招商条件确认':val==21?'首期费用收缴完成':val==31?'工程作业完成':val==41?'房屋交付':val==42?'施工前备案':val==43?'门店手续办理':val==44?'商户施工进场':val==45?'商户完工':val==46?'商户开业证照办理':val==51?'商户开业':val==61?'商户撤场':''
        },
        getprosubtime(val){
            return val==41?'最新房屋预计交付':val==42?'备案办理完成':val==43?'门店手续办理':val==44?'商户施工进场':val==45?'商户完工':val==46?'商户开业证照手续办理':val==51?'商户开业':''
        },
        getprosubsjtime(val){
            return val==41?'房屋实际交付时间':val==42?'备案实际办理时间':val==43?'手续实际办理时间':val==44?'商户实际进场时间':val==45?'商户实际完工时间':val==46?'证照实际办理时间':val==51?'实际开业时间':val==61?'商户实际撤场时间':''
        },
    },
}
</script>

<style scoped>
.ma16{
    margin: 16px;
    
}
.ma16 .w10{
    width: 40px;
}
.row-between{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tips{
    font-size: 12px;
    color: #606266;
}
.wshop{
    box-sizing: border-box;
    padding: 20px 0; 
}
.btnfoot{
    margin-top: 20px;
    width: 80%;
    margin: 20px auto 0;
    display: flex;
    justify-content: space-between;
    /* text-align: center; */
}
.scroll{
    width: 100%;
    max-height: 60vh;
    min-height: 30vh;
    overflow-y: auto;
}
.lan{
    color: #3332B5;
}
.red{
    color: red;
}
.row-flex{
    display: flex;
    justify-content: space-between;
}
.page{
    min-height: 100vh;
    background: #fafafa;
}
.m-t-15{
    margin-top: 15px;
}
.mt20{
    margin-top: 20px;
    text-align: center;
}
.mb20{
    /* margin-bottom: 20px; */
    padding-bottom: 20px;
}
.custom-image{
    padding: 10px 20px;
}
.custom-image >>>.van-empty__image {
    width: 90px;
    height: 72px;
}
.shadow{
     box-shadow: 0 4px 8px 0 #ebedf0, 0 6px 10px 0 #ebedf0;
     /* border:1px solid #fafafa; */
     margin-bottom: 10px;
     border-radius: 5px;
}
.t_box,.t_top{
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
}
.t_box .item,.t_top .item{
    width: 50%;
    box-sizing: border-box;
    padding: 5px;
    text-align: right;
    color: #646566;
    font-size: 12px;
    line-height: 1.5;
    word-break: break-all;
}
.t_top{
    background: #3332B5;
    color: #fff;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 10px 0;
}
.t_top .item{
    font-size: 14px;
    padding: 3px 5px;
    text-align: left;
}
.t_top .item span{
    color: #fff;
}
.t_box .item span{
    color: #323233;
}
/* .t_box .item:nth-child(2n){
    text-align: right;
} */
.t_box .left{
    text-align: left;
}
.t_box .w100{
    width: 100%;
    text-align: left !important; 
}
.t_top .w100{
    width: 100%;
    font-size: 18px;
    text-align: center !important; 
}
>>> .van-grid-item .van-grid-item__content{
    align-items: flex-start;
}
>>> .van-grid-item:nth-child(2n) .van-grid-item__content{
    align-items: flex-end;
}
>>> .van-grid-item__content{
    padding: 5px;
}
>>> .van-collapse-item{
    margin-bottom: 8px;
}
>>> .van-dialog__content{
    text-align: center;
}
>>> .van-button--small{
    padding: 0 20px;
}
>>> .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
    display: none;
}
.lv >>> .van-cell__value{
    color: #07c160;
}
.jg >>> .van-cell__value{
    color: #e6a23c;
}
>>> .van-field__label,>>> .van-cell__value{
    color: #323233;
}
.cnoline >>> .van-cell{
    padding: 8px 16px;
}
.cnoline >>> .van-cell::after{
    display: none !important;
}
.noline >>> .van-cell{
    padding: 3px 16px;
}
.noline >>> .van-cell::after,.rebox::after{
    display: none !important;
}
.bhbj{
    background: #fafafa;
    border-radius: 5px;
}
.bhbj >>> .van-cell{
    background: #fafafa;
    font-size: 12px;
    line-height: 1.5;
}
.mauto{
    text-align: center;
}
.dlist .m-b-15 .noline{
    margin-bottom: 15px;
}
.dlist .m-b-15 .noline:last-child{
    margin-bottom: 0;
}
.dlist >>>.van-cell:nth-child(1){
    font-weight: bold;
    color: red;
}
>>> .van-collapse-item__title .van-cell__title{
    position: relative;
    padding-left: 14px;
}
>>> .van-collapse-item__title .van-cell__title::after{
    position: absolute;
    content: "";
    width: 4px;
    height: 16px;
    background: #3332B5;
    top: 50%;
    margin-top: -8px;
    border-radius: 5px;
    left: 0;
}
>>> .van-grid{
    border-left: 0.5px solid #ebedf0;
}
.hbj >>> .van-field__body .van-field__control{
    background: #fafafa;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 5px;
}
.wval >>>.van-cell__value{
    flex: 2 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/lifecycle.vue